import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';
import {
  ACCOUNT_TYPE_ICONS,
  ACCOUNT_TYPE_LABEL_KEYS,
} from '../config/accountTypeMeta';
import type { TradingAssetAccountEntry, TradingAssetRow } from '../model';

type Props = {
  row: TradingAssetRow;
  account: TradingAssetAccountEntry;
  className?: string;
};

const TradingAccountEntryLabel = ({ row, account, className }: Props) => {
  const { t } = useTranslation();
  const TypeIcon = ACCOUNT_TYPE_ICONS[account.accountType];

  return (
    <span
      className={cn(
        'flex items-center gap-[0.4rem] min-w-0 medium5 text-primary',
        className
      )}>
      {row.icon && (
        <img
          className="size-[1.6rem] rounded-full shrink-0"
          src={row.icon}
          alt={row.code}
        />
      )}
      <span className="truncate">{row.code}</span>
      <span className="text-secondary shrink-0">
        {t('personalAccount.tradingAccounts.onAccount')}
      </span>
      <span className="flex items-center gap-[0.4rem] pl-[0.3rem] shrink-0">
        <TypeIcon className="size-[1.6rem] text-primary" />
        {t(ACCOUNT_TYPE_LABEL_KEYS[account.accountType])}
      </span>
    </span>
  );
};

export { TradingAccountEntryLabel };
